export default __webpack_public_path__ + "locales/en/PeopleTranslations.json?hash=ac318f5725e7a25fc941e34b80d35b0e";